import { AdvantageItem } from '@/components/about/AdvantageItem';
import { ArrowIcon } from '@/app/icons/about/ArrowIcon';
import { BellIcon } from '@/app/icons/about/BellIcon';
import { ClockIcon } from '@/app/icons/about/ClockIcon';
import { CreditCardIcon } from '@/app/icons/about/CreditCardIcon';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { ImageIcon } from '@/app/icons/about/ImageIcon';
import { LockIcon } from '@/app/icons/about/LockIcon';
import { ShieldIcon } from '@/app/icons/about/ShieldIcon';
import { SupportIcon } from '@/app/icons/about/SupportIcon';
import { Theme } from '@mui/material/styles';
import { TimerIcon } from '@/app/icons/about/TimerIcon';
import React, { FC, ReactElement } from 'react';

export const AdvantageContainer: FC = (): ReactElement => {
  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={isMobile ? 4 : 5}>
      <Grid item={true}>
        {isMobile ? (
          <Typography fontStyle={'normal'} fontWeight={'500'} fontSize={'16px'} lineHeight={'24px'}>
            {'Чем это лучше обычного письма?'}
          </Typography>
        ) : (
          <Typography variant={'h2'}>{'Чем это лучше обычного письма?'}</Typography>
        )}
      </Grid>
      <Grid item={true} xs={true}>
        <Grid container={true} columnSpacing={7} rowSpacing={isMobile ? 4 : 5}>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<ClockIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Круглосуточный приём сообщений'}
              description={'Служба поддержки наших клиентов 24/7;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<TimerIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Быстрая доставка сообщений до учреждения'}
              description={'Время доставки писем и бланков ответов в самые кратчайшие сроки;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<ImageIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Возможность отправить фотографии'}
              description={'Делитесь самыми важными моментами с близкими и родственниками;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<CreditCardIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={isMobile ? 'Удобные формы оплаты' : 'Удобные формы\nоплаты'}
              description={'Банковские карты и СБП;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<BellIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Уведомления о каждом этапе обработки письма'}
              description={'Получение платежа, отправка цензору, доставка адресату, ответ на ваше письмо;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<ShieldIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={isMobile ? '100% гарантия доставки' : '100% гарантия\nдоставки'}
              description={'В случае наличия адресата в данном учреждении и прохождения цензуры;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<ArrowIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Возможность получить ответ на письмо'}
              description={'В виде сканированной копии рукописного письма адресата;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<SupportIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Оперативная служба поддержки'}
              description={'Быстро отвечаем на ваши обращения и вопросы;'}
            />
          </Grid>
          <Grid item={true} md={3} sm={4} xs={12}>
            <AdvantageItem
              isMobile={isMobile}
              icon={<LockIcon sx={{ width: '40px', height: '40px' }} />}
              tittle={'Защита персональных данных'}
              description={'Криптографический метод, имеющий сертификат ФСТЭК.'}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
